import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

type QueryState<T> = {
    state: Record<string, string> | T;
    setQueryState: (
        query: Record<string, string> | T,
        callback?: () => void
    ) => void;
};

export function useQueryState<T>(
    initState: Record<string, string>
): QueryState<T> {
    const [state, setState] = useState<Record<string, string> | T>(initState);
    const location = useLocation();
    const pathname = location.pathname;
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const setQueryState: QueryState<T>["setQueryState"] = (query, callback) => {
        const queryString = new URLSearchParams(
            query as Record<string, string>
        ).toString();

        const newPathName = `${pathname}?${queryString}`;
        if (callback) {
            callback();
        }

        navigate(newPathName);
    };

    useEffect(() => {
        // if (!searchParams.toString()) return setQueryState(initState);

        const queryString = searchParams.toString();

        const queryObject: Record<string, string> = {};

        queryString.split("&").forEach((pair) => {
            const [key, value] = pair.split("=");
            queryObject[key] = value;
        });

        setState((prev) => ({
            ...prev,
            ...queryObject,
        }));
    }, [searchParams]);

    return { state, setQueryState };
}
